package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.attributes.builders.TextAreaAttrsScope
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.dom.TextArea

@Composable
fun WebTextArea(
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String = "",
    rows: Int = 4,
    enabled: Boolean = true,
    ariaLabel: String? = null,
    id: String? = null,
    name: String? = null,
    describedBy: String? = null,
    required: Boolean = false,
) {
    TextArea(
        value = value,
        attrs = WebFieldStyle.toAttrs<TextAreaAttrsScope> {
            onInput { onValueChange(it.value) }
            if (placeholder.isNotEmpty()) attr("placeholder", placeholder)
            attr("rows", rows.toString())
            if (!enabled) disabled()
            if (ariaLabel != null) attr("aria-label", ariaLabel)
            if (id != null) id(id)
            if (name != null) attr("name", name)
            if (describedBy != null) attr("aria-describedby", describedBy)
            if (required) attr("required", "")
            style { property("resize", "vertical") }
        }
    )
}
